import { ActivatedRouteSnapshot, Routes } from '@angular/router';

import { ClientConfigProductName } from '@frontend/vanilla/core';

import { clientConfigAppGuard } from '../guards';

export default [
    {
        path: 'lotto',
        // eslint-disable-next-line @nx/enforce-module-boundaries
        loadChildren: () => import('../../../lottery/app/src/lottery.routes').then((t) => t.LottoRoutesModule),
        canMatch: [(route: ActivatedRouteSnapshot) => clientConfigAppGuard(route)],
        data: { product: ClientConfigProductName.LOTTO },
    },
] satisfies Routes;
